import React, { useEffect, useState, useCallback, useRef } from "react";
import { useHistory } from "react-router-dom";
import FileSaver from "file-saver";
import i18n from "i18n";

import { OrderService } from "../../../../../services/OrderService";
import { MovementService } from "../../../../../services/MovementServkce";
import { StockService } from "../../../../../services/StockService";

import { EventRepository } from "helpers/EventRepository";

import { WSService } from "services/WSServices";
import useRequest from "hooks/useRequest";

import { itemsByItem } from "helpers/orders/MovementHelper";
import { parseItems } from "helpers/orders/ItemHelper";

import styles from "./PrepOrders.OrderDetail.module.scss";
import AdminLayout from "../../../../../components/MainApp/layouts/DesktopLayout";
import OrderDetailDescriptionPanel from "../../../../../components/MainApp/organisms/Orders/RequestOrders/Detail/Description";
import OrderProductSummary from "../../../../../components/MainApp/organisms/Orders/RequestOrders/ProductSummary";

import OrderPills from "../../../../../components/MainApp/atoms/Pills/OrderPills";
import MainButton from "../../../../../components/MainApp/atoms/RoundedButton";
import RejectModal from "../../../../../components/MainApp/organisms/Orders/RequestOrders/Modals/RejectModal";
import Loader from "../../../../../components/MainApp/atoms/Loader";
import { isMobile } from "../../../../../helpers/Mobile";
import ItemTags from "components/MainApp/organisms/OrdersV3/Item-Tags";

import LoadMovementItems from "./LoadMovementItems";
import VerifyMovementItems from "./VerifyMovementItems";
import ValidateMovementItems from "./ValidateMovementItems";
import GenericErrorModal from "components/MainApp/atoms/Modals/GenericErrorModal";
import isFirstDayOfMonth from "date-fns/isFirstDayOfMonth/index.js";
import { capitalize } from "helpers/utils/utils_general";
import clockIcon from "assets/images/clock-icon.svg";
import calendarIcon from "assets/images/calendar-icon.svg";
import downloadIcon from "assets/images/download-icon.svg";
import defaultImage from "assets/images/default-image.png";

let globalVerifyMovementItems = [];

export const PrepOrderDetailsView = props => {
  const history = useHistory();

  const {
    loading,
    beforeSubmit,
    afterSubmit,
    errors,
    dealWithError
  } = useRequest();

  const [step, setStep] = useState(0);
  // Step 0
  const [order, setOrder] = useState({});
  const [orderDescription, setorderDescription] = useState([]);
  const [modalOpen, setmodalOpen] = useState(false);
  const [products, setproducts] = useState([]);
  const [totalUnits, setTotalUnits] = useState(0);
  const [movement, setmovement] = useState({});
  const [movementItems, setmovementItems] = useState([]);
  // Step 1
  const [groupMovementItems, setGroupMovementItems] = useState([]);
  // Step 3
  const [verifyMovementItems, setVerifyMovementItems] = useState([]);
  const [validatedItems, setValidatedItems] = useState(0);

  const [errorModalOpen, seterrorModalOpen] = useState(false);
  const [errorMsg, seterrorMsg] = useState("");

  const movementRef = useRef(movement);
  const orderRef = useRef(order);
  const [destination, setDestination] = useState("")

  const headerOptions = isMobile
    ? [
      {
        icon: "icon-iconos_descargar",
        name: "Descargar",
        handler: () => {
          downloadVoucher();
        },
        tooltip: i18n.t("download")
      }
    ]
    : [];

  const goBackModal = () => {
    history.push("/admin/orders/preparation");
  };

  useEffect(() => {
    const id = props.match.params.key;
    const node = props.match.params.node ?? "";
    beforeSubmit();
    OrderService.prepOrder(id, node)
      .then(order => {
        afterSubmit();
        setOrder(order);
        const orderDescriptionNew = order.getDescriptionPanelView();
        if (order.order) {
          getDetination(order, orderDescriptionNew);
        } else {
          setorderDescription(orderDescriptionNew);
        }
        getItems(order.id, node);
        // Esta llamada la hace getItems porque para hacer el parseo se
        // requiere tener ambos.
        // getMovements();
      })
      .catch(_ => {
        afterSubmit();
      });
  }, []);

  const getDetination = (order, orderDescriptionNew) => {
    OrderService.relocationOrder(order.order.id).then((order) => {
      orderDescriptionNew.push({
        title: capitalize(i18n.t("destination")),
        value: order.destination.name,
      })
      setorderDescription(orderDescriptionNew);
    }).catch(_ => {
      orderDescriptionNew.push({
        title: capitalize(i18n.t("destination")),
        value: '',
      });
      setorderDescription(orderDescriptionNew);
      afterSubmit();
    });

  }

  useEffect(() => {
    if (!order || !order.id) return;
    // si orderDescription tiene un motivo de rechazo con valor no vacío, no hacemos nada
    if (
      orderDescription &&
      orderDescription.find(
        item => item.title === i18n.t("reason.rejection") && item.value
      )
    )
      return;
    OrderService.getOrderStatus(order.id)
      .then(response => {
        const orders = Object.values(response);
        const rejectedOrder = orders.find(order => order.status === "REJ");
        if (rejectedOrder && rejectedOrder?.reason) {
          const orderDescriptionNew2 = [
            ...orderDescription,
            { title: i18n.t("reason.rejection"), value: rejectedOrder.reason }
          ];
          setorderDescription(orderDescriptionNew2);
        } else if (order?.order) {
          // buscamos en la orden de la que depende esta el motivo
          OrderService.getOrderStatus(order?.order?.id)
            .then(response => {
              const orders = Object.values(response).filter(
                item => item && typeof item === "object"
              );
              let reason = orders.reduce((r, order) => order?.reason || r, "");
              if (orderDescription) {
                const orderDescriptionNew2 = [
                  ...orderDescription,
                  { title: i18n.t("reason.rejection"), value: reason }
                ];
                setorderDescription(orderDescriptionNew2);
              }
            })
            .catch(_ => {
              afterSubmit();
            });
        }
      })
      .catch(_ => {
        afterSubmit();
      });
  }, [orderDescription]);

  useEffect(() => {
    globalVerifyMovementItems = verifyMovementItems;
  }, [verifyMovementItems]);

  useEffect(() => {
    if (!movement.id) return;

    movementRef.current = movement;
    if (movementItems.length === 0) {
      getMovementItems();
    }
  }, [movement]);

  useEffect(() => {
    orderRef.current = order;
    if (movementItems.length === 0) {
      getMovementItems();
    }
  }, [order]);

  useEffect(() => {
    setGroupMovementItems(itemsByItem(movementItems, products));

    const verifyItems = itemsByItem(movementItems, products);
    setVerifyMovementItems(verifyItems);
    setValidatedItems(0); // Por defecto nada validado
  }, [movementItems]);

  const getItems = (orderId, node = "") => {
    OrderService.getItems(orderId, node).then(response => {
      const productList = parseItems(response);
      const total = [...productList].reduce(function (a, prod) {
        return a + prod.units;
      }, 0);
      setproducts(productList);
      setTotalUnits(total);
      // Now get movement items
      getMovements(orderId, node);
    });
  };

  const getMovements = (orderId, node = "") => {
    OrderService.roadMap(orderId, node).then(response => {
      response = response.filter(result => {
        return result.movement.status !== "CAN";
      });
      if (response.length !== 0) {
        const movement = response[response.length - 1].movement;
        setmovement(movement);
      }
    });
  };

  const getMovementItems = () => {
    if (!movement.id) return;
    MovementService.items(movement.id).then(response => {
      setmovementItems(response);
    });
  };

  const receiveEvent = useCallback(payload => {
    const ws = WSService.getInstance();

    if (payload.method === "EVENT" && payload.room && ws.inRoom(payload.room)) {
      if ("items" in payload.params
        && payload.params["items"] != null
        && payload.params["items"].length > 0) {

        setmovementItems(payload.params.items);
      } else {
        if (orderRef.current && orderRef.current.status === "PRO") {
          handleStockSearch(payload.params.epc ? payload.params.epc : payload.params.tag["rfid"])
        }
        if (orderRef.current && orderRef.current.status === "SUP") {
          handleTagSearch(payload.params.epc ? payload.params.epc : payload.params.tag["rfid"]);
        }
      }
    }
  }, []);

  const handleRejectModalOpen = () => {
    setmodalOpen(true);
  };

  const handleCloseModal = () => {
    setmodalOpen(false);
  };

  const handleReject = reason => {
    beforeSubmit();
    if (order.status === "PEN" || order.status === "PRO" || order.status === "SUP") {
      handleRejectFromPen(reason);
    }
    setmodalOpen(false);
  };

  const handleRejectFromPen = reason => {
    OrderService.changeOrderStatus(order.id, "REJ", reason)
      .then(response => {
        setmodalOpen(false);
        afterSubmit();
        EventRepository.notificationSend({
          label: i18n.t("order.was.successfully.rejected"),
          type: "success"
        });
        props.history.push("/admin/orders/preparation");
      })
      .catch(error => {
        afterSubmit();
        dealWithError(error, "generic.error", (message, errors) => {
          if (Object.keys(errors).length === 0) {
            EventRepository.notificationSend({
              label: message,
              type: "error"
            });
          } else {
            EventRepository.notificationSend({
              label: i18n.t("order.cannot.refused"),
              type: "error"
            });
          }
        });
      });
  };

  const handleApprove = () => {
    if (order.status !== "PEN" && order.status === "SUP") {
      if (validatedItems < totalUnits) {
        seterrorModalOpen(true);
        seterrorMsg(i18n.t("all.tags.readings.are.yet.performed"));
        return;
      }
    }
    beforeSubmit();
    if (order.status === "PEN") handleAppoveFromPen();
    if (order.status === "SUP") handleApproveFromSup();
  };

  const handleAppoveFromPen = () => {
    OrderService.changeOrderStatus(order.id, "PRO", "apporoved")
      .then(response => {
        afterSubmit();
        setmodalOpen(false);

        EventRepository.notificationSend({
          label: i18n.t("order.was.successfully.approved"),
          type: "success"
        });
        props.history.push("/admin/orders/preparation");
      })
      .catch(error => {
        afterSubmit();
        dealWithError(error, "generic.error", (message, errors) => {
          if (Object.keys(errors).length === 0) {
            EventRepository.notificationSend({
              label: message,
              type: "error"
            });
          } else {
            EventRepository.notificationSend({
              label: i18n.t("order.cannot.refused"),
              type: "error"
            });
          }
        });
      });
  };

  const handleApproveFromSup = () => {
    const tagsList = [];
    verifyMovementItems?.forEach(item => item.tags?.forEach(tag => tagsList.push(tag.tag)));

    MovementService.changeStatus(movement.id, "VER_COM", tagsList)
      .then(response => {
        afterSubmit();
        EventRepository.notificationSend({
          label: i18n.t("order.was.successfully.dispatched"),
          type: "success"
        });
        props.history.push("/admin/orders/preparation");
      })
      .catch(error => {
        afterSubmit();
        dealWithError(error, "generic.error", (message, errors) => {
          if (Object.keys(errors).length === 0) {
            EventRepository.notificationSend({
              label: message,
              type: "error"
            });
          } else {
            EventRepository.notificationSend({
              label: i18n.t("order.cannot.dispatched"),
              type: "error"
            });
          }
        });
      });
  };

  const handleInitMovement = () => {
    if (!movement.id) {
      const data = order.dataCreateMovement();
      OrderService.addMovement(order.id, data)
        .then(response => {
          setmovement(response.movement);
          setStep(1);
        })
        .catch(error => {
          afterSubmit();
          dealWithError(error, "generic.error", (message, errors) => {
            if (Object.keys(errors).length === 0) {
              EventRepository.notificationSend({
                label: message,
                type: "error"
              });
            } else {
              EventRepository.notificationSend({
                label: i18n.t("cannot.start.movement"),
                type: "error"
              });
            }
          });
        });
    } else {
      setStep(1);
    }
  };

  const handleDeleteMovementItems = tag => {
    beforeSubmit();
    MovementService.deleteItems(movement.id, [{ id: tag.movement_item_id }])
      .then(response => {
        afterSubmit();
        setmovementItems(response);
      })
      .catch(error => {
        afterSubmit();
      });
  };

  const handleDeleteAllMovementItems = e => {
    const ids = movementItems.map(m => {
      return { id: m.id };
    });
    beforeSubmit();
    MovementService.deleteItems(movement.id, ids)
      .then(response => {
        afterSubmit();
        setmovementItems(response);
      })
      .catch(error => {
        afterSubmit();
      });
  };

  const handleContinueInitMovement = () => {
    let expectedUnits = true;
    let exceededUnits = false;

    groupMovementItems.forEach(item => {
      if (item.expectedUnits == 0) {
        expectedUnits = false;
      } else {
        if (item.expectedUnits < item.tags.length) {
          exceededUnits = true;
        }
      }
    });

    if (movementItems.length < totalUnits) {
      seterrorModalOpen(true);
      seterrorMsg(i18n.t("all.tags.readings.are.yet.performed"));
      return;
    }

    if (!expectedUnits) {
      seterrorModalOpen(true);
      seterrorMsg(i18n.t("products.werenot.requested"));
      return;
    }

    if (exceededUnits) {
      seterrorModalOpen(true);
      seterrorMsg(i18n.t("products.added.exceeds.requested"));
      return;
    }
    setStep(2);
  };

  const handleStockSearch = cod => { // valida el item en otras ordenes
    cod = cod?.trim();
    if (!cod) return;

    const filter = {
      location__node: movementRef.current.node.code,
      status: "LOC",
      tag__rfid: cod,
      check_rfid_other_orders: orderRef.current?.code ?? ""
    };
    beforeSubmit();
    StockService.stock(filter)
      .then(response => {
        if (response.count === 0) {
          afterSubmit();
          handleTagSearch(cod);
          return;
        }
        const stock = response.results[0];
        MovementService.addItems(movement.id, [
          {
            item_stock: stock.id
          }
        ])
          .then(response => {
            afterSubmit();
            setmovementItems(response);
          })
          .catch(error => {
            afterSubmit();
            dealWithError(error, "generic.error", (message, _) => {
              EventRepository.notificationSend({
                label: message,
                type: "error"
              });
            });
          });
      })
      .catch(_ => {
        afterSubmit();
        dealWithError(_, "generic.error", (message, _) => {
          EventRepository.notificationSend({
            label: message,
            type: "error"
          });
        });
      });
  };

  const handleConfirmMovement = () => {
    const status = movement.requires_revision ? "CLO" : "COM";
    beforeSubmit();
    MovementService.changeStatus(movement.id, status)
      .then(_ => {
        afterSubmit();
        EventRepository.notificationSend({
          label: i18n.t("order.was.successfully.prepared"),
          type: "success"
        });
        props.history.push("/admin/orders/preparation");
      })
      .catch(error => {
        afterSubmit();
        dealWithError(error, "generic.error", message => {
          EventRepository.notificationSend({
            label: message,
            type: "success"
          });
        });
      });
  };

  const handleInitVerify = () => {
    setStep(3);
  };

  const handleTagSearch = cod => {
    cod = cod?.trim();
    if (!cod) return;

    let verifyItems = [...globalVerifyMovementItems];
    let exist = false;
    // Buscar EPC
    verifyItems.forEach((i, index, arr) => {
      i.tags.forEach((t, indexTag) => {
        if (t.tag === cod) {
          exist = true;
          arr[index]["tags"][indexTag]["selected"] = true;
        }
      });
    });

    if (exist) {
      setVerifyMovementItems(verifyItems);

      // Calcular cantidad validados
      let cant = 0;
      verifyItems.forEach(i => {
        i.tags.forEach(t => {
          if (t.selected) cant++;
        });
      });
      setValidatedItems(cant);
    } else {
      seterrorModalOpen(true);
      if (orderRef.current && orderRef.current.status === "SUP") {
        seterrorMsg(i18n.t("tag.read.isnot.loaded.order", { cod: cod }));
      } else {
        seterrorMsg(i18n.t("tag.read.isnot.loaded.sistem", { cod: cod }));
      }
    }

  };

  const handleChangeStep = step => {
    setStep(step);
  };

  const downloadVoucher = () => {
    beforeSubmit();
    OrderService.prepDownloadVoucher(order.id)
      .then(blob => {
        afterSubmit();
        FileSaver.saveAs(blob, "comprobante.pdf");
      })
      .catch(error => {
        afterSubmit();
      });
  };

  const handleClickMobileReject = (step) => {
    handleRejectModalOpen();
    if (step != -1) setStep(step);
  };

  const customButtonsMobile = (step = -1) => {
    return (
      <>
        <div className={styles["prep-order-details-reject"]}>
          <MainButton
            handleClick={() => handleClickMobileReject(step)}
            state={"enabled"}
            legend={i18n.t("decline")}
          ></MainButton>
        </div>

        {!order?.status?.match(/^(PRO|SUP)$/i) && (
          <div className={styles["prep-order-details-approve"]}>
            <MainButton
              handleClick={handleApprove}
              state={"enabled"}
              legend={i18n.t("approve")}
            ></MainButton>
          </div>
        )}
      </>
    );
  };

  const customButtons = () => {
    return (
      <div className={styles["prep-order-details-custom-buttons"]}>
        <div className={styles["prep-order-details-reject"]}>
          <MainButton
            handleClick={handleRejectModalOpen}
            state={"enabled"}
            legend={i18n.t("decline")}
          ></MainButton>
        </div>

        {!order?.status?.match(/^(PRO|SUP)$/i) && (
          <div className={styles["prep-order-details-approve"]}>
            <MainButton
              handleClick={handleApprove}
              state={"enabled"}
              legend={i18n.t("approve")}
            ></MainButton>
          </div>
        )}
      </div>
    );
  };

  const btnReject = () => (
    <div className={styles["prep-order-details-custom-buttons"]}>
      <div className={styles["prep-order-details-reject"]}>
        <MainButton
          handleClick={handleRejectModalOpen}
          state={"enabled"}
          legend={i18n.t("decline")}
        ></MainButton>
      </div>
    </div>
  );

  const loadedContentStep0 = (
    <div className={styles["prep-order-details-wrapper"]}>
      <div className={styles["prep-order-details-panels"]}>
        <div className={styles["prep-order-details-left"]}>
          <div className={styles["prep-order-details-left-title"]}>
            <div className={styles["prep-order-details-title"]}>
              {i18n.t("preparation.order")}
            </div>
            <img
              src={calendarIcon}
              alt="calendar icon"
              className={styles["calendar_icon"]}
            />
            <div className={styles["prep-order-details-date"]}>
              {order.created_at &&
                new Date(order.created_at).toLocaleDateString("es-ES", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric"
                })}
            </div>
            <img src={clockIcon} alt="clock icon" />
            <div className={styles["prep-order-details-time"]}>
              {order.created_at &&
                new Date(order.created_at).toLocaleTimeString("es-ES", {
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit"
                })}
            </div>
            <div className={styles["pill-wrapper"]}>
              {order && (
                <OrderPills big={true} state={order.status}></OrderPills>
              )}
            </div>
          </div>
          <div className={styles["prep-order-details-panel"]}>
            <div className={styles["order-detail-description-panel-container"]}>
              <OrderDetailDescriptionPanel
                order={orderDescription.filter(
                  item =>
                    item.title.toLowerCase() !==
                    i18n.t("creation.date").toLowerCase()
                )}
              ></OrderDetailDescriptionPanel>
            </div>
          </div>
        </div>
        <div className={styles["prep-order-details-right"]}>
          {!isMobile && (
            <div
              className={`${styles["prep-order-details-right-title"]} ${
                !isMobile && order && order.status?.match("PRO|PEN")
                  ? styles["two-elements"]
                  : ""
              }`}
            >
              <div
                className={styles["prep-order-details-download"]}
                onClick={downloadVoucher}
              >
                <img src={downloadIcon} alt="download icon" className={styles["prep-order-details-download-icon"]} />
                <div className={styles["prep-order-details-download-text"]}>
                  {" "}
                  {i18n.t("download.detail")}{" "}
                </div>
              </div>
              {!isMobile && order && ["PEN"].includes(order.status) && (
                <div className={styles["prep-order-order-details-button"]}>
                  {customButtons()}
                </div>
              )}
              {!isMobile && order && order.status === "PRO" && (
                <>
                  <div
                    className={styles["prep-order-details-init-movement"]}
                    onClick={handleInitMovement}
                  >
                    {i18n.t("place.order")}
                  </div>
                  {btnReject()}
                </>
              )}
              {!isMobile && order && order.status === "SUP" && (
                <>
                  <div
                    className={styles["prep-order-details-init-movement"]}
                    onClick={handleInitVerify}
                  >
                    {i18n.t("verify.movement")}
                  </div>
                  {btnReject()}
                </>
              )}
            </div>
          )}
          <div className={styles["prep-order-details-panel"]}>
            <div className={styles["prep-order-details-panel-wrapper"]}>
              <div className={styles["prep-order-details-panel-products-header"]}>
                <div className={styles["left-group"]}>
                  <div className={styles["prep-order-details-panel-products-header-text"]}>
                    {i18n.t("products")}
                  </div>
                  <div className={styles["prep-order-details-panel-products-header-products-number"]}>
                    {products.length}
                  </div>
                </div>

                <div className={styles["prep-order-details-panel-products-header-tags-number"]}>
                  {groupMovementItems
                    .map(item => item.tags.length)
                    .reduce((a, b) => a + b, 0)} {i18n.t("units")}
                </div>
              </div>
            </div>
            <div className={styles["prep-order-details-panel-wrapper"]}>
              <div className={styles["prep-order-details-products"]}>
                {["PRO", "SUP", "DISP", "COM"].includes(order.status) &&
                  groupMovementItems.map(item => {
                    return (
                      <React.Fragment key={item.sku}>
                        <div
                          className={
                            styles["prep-order-details-products-item-container"]
                          }
                        >
                          <div
                            className={
                              styles[
                                "prep-order-details-products-item-header-img"
                              ]
                            }
                          >
                            <img
                              src={
                                item.item_files?.length > 0
                                  ? item.item_files[0].file_name
                                  : defaultImage
                              }
                              alt={
                                item.item_files?.length > 0 ? item.title : ""
                              }
                            />
                          </div>
                          <div
                            className={
                              styles["prep-order-details-products-item-header"]
                            }
                          >
                            <div
                              className={
                                styles[
                                  "prep-order-details-products-item-header-title"
                                ]
                              }
                            >
                              {item.title}
                            </div>
                            <div
                              className={
                                styles[
                                  "prep-order-details-products-item-header-subtitle"
                                ]
                              }
                            >
                              {item.sku}
                            </div>
                          </div>
                        </div>

                        {item.tags.length > 0 && (
                          <div
                            className={
                              styles[
                                "prep-order-details-products-tags-table-header"
                              ]
                            }
                          >
                            <div className={styles["first-column"]}>{i18n.t("epc")}</div>
                            <div>{i18n.t("batch")}</div>
                            <div>{i18n.t("expiry")}</div>
                          </div>
                        )}
                        {item.tags.map((tag, index) => (
                          <div
                            key={index}
                            className={
                              styles["prep-order-details-products-tags-items"]
                            }
                          >
                            <div className={styles["first-column"]}>
                              {tag.epc}
                            </div>
                            <div>{tag.batch}</div>
                            <div>
                              {tag.expiration_date &&
                                new Date(
                                  tag.expiration_date
                                ).toLocaleDateString("es-ES", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric"
                                })}
                            </div>
                          </div>
                        ))}
                      </React.Fragment>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>

      {isMobile && order && order.status === "PEN" && (
        <div className={styles["prep-order-details-button"]}>
          {customButtons()}
        </div>
      )}
      {isMobile && order && order.status === "PRO" && (
        <div className={styles["prep-order-details-button"]}>
          <div
            className={styles["prep-order-details-init-movement"]}
            onClick={handleInitMovement}
          >
            {i18n.t("place.order")}
          </div>
          {customButtonsMobile(0)}
        </div>
      )}
      {isMobile && order && order.status === "SUP" && (
        <div className={styles["prep-order-details-button"]}>
          <div
            className={`${styles["prep-order-details-init-movement"]} ${styles["verify-movement"]}`}
            onClick={handleInitVerify}
          >
            {i18n.t("verify.movement")}
          </div>
          {customButtonsMobile()}
        </div>
      )}
    </div>
  );

  const loadedContentStep1 = (
    <LoadMovementItems
      total={totalUnits}
      originalItems={movementItems}
      selectedItems={groupMovementItems}
      handleDelete={handleDeleteMovementItems}
      handleSearch={handleStockSearch}
      handleDeleteAll={handleDeleteAllMovementItems}
      handleSend={handleContinueInitMovement}
      handleReject={handleRejectModalOpen}
      goBack={() => handleChangeStep(0)}
      enabledRead={true}
      typeRead={"ORDERS"}
      refRead={order.id}
      receiveEvent={receiveEvent}
    />
  );

  const loadedContentStep2 = (
    <VerifyMovementItems
      originalItems={movementItems}
      selectedItems={groupMovementItems}
      totalSolicited={totalUnits}
      handleEdit={() => handleChangeStep(1)}
      handleConfirm={handleConfirmMovement}
      handleBack={() => handleChangeStep(1)}
    />
  );

  const loadedContentStep3 = (
    <ValidateMovementItems
      total={movementItems.length}
      totalValidate={validatedItems}
      selectedItems={verifyMovementItems}
      handleSearch={handleTagSearch}
      handleReject={handleRejectModalOpen}
      handleApprove={handleApprove}
      goBack={() => handleChangeStep(0)}
      enabledRead={true}
      typeRead={"READ"}
      refRead={""}
      receiveEvent={receiveEvent}
    />
  );

  const loadedContent = [
    loadedContentStep0,
    loadedContentStep1,
    loadedContentStep2,
    loadedContentStep3
  ];
  const content = order.id ? loadedContent[step] : <></>;

  return (
    <div className={styles["prep-order-details-container"]}>
      <AdminLayout
        headerTitle={i18n.t("order.detail")}
        headerOptions={headerOptions}
        content={content}
        goBackFunc={goBackModal}
        navHidden={true}
      ></AdminLayout>

      <RejectModal
        open={modalOpen}
        handleClose={handleCloseModal}
        handleReject={handleReject}
      ></RejectModal>

      <GenericErrorModal
        open={errorModalOpen}
        handleClose={() => seterrorModalOpen(false)}
        error={errorMsg}
      ></GenericErrorModal>

      {loading && <Loader />}
    </div>
  );
};

export default PrepOrderDetailsView;
